/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Dialog_DescInputs */

const vi_stock_out_dialog_desc = /** @type {(inputs: Stock_Out_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô lấy hàng cho từng sản phẩm. Số lượng đã khoá theo đơn.`)
};

/**

* @param {Stock_Out_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_dialog_desc = /** @type {((inputs?: Stock_Out_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_dialog_desc(inputs)
});